/**
 * Serialise a list-query params object into a URL query string.
 *
 * Omits `undefined`, `null` and `""` so a cleared filter sends no parameter at
 * all — `?search=` is a different request from one with no `search`, and the
 * backend trims and matches whatever it receives. `false` and `0` are kept:
 * `paginate=false` is the whole point of the unpaginated mode.
 *
 * Takes `object` rather than `Record<string, unknown>` because the params types
 * are declared with `interface`, and an interface has no implicit index
 * signature — so it is not assignable to a Record. This is a compile error, not
 * a style preference.
 */
export function toQueryString(params?: object): string {
  if (!params) return "";
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    usp.append(key, String(value));
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
}
